var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNexaasLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_25852",
    "data-name": "Grupo 25852",
    xmlns: "http://www.w3.org/2000/svg",
    width: 137.844,
    height: 41.205,
    viewBox: "0 0 137.844 41.205",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_217",
    "data-name": "Grupo 217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_299",
    "data-name": "Caminho 299",
    d: "M609.478,205.149a4.274,4.274,0,0,1-4.274-4.274V168.218a4.274,4.274,0,0,1,8.547,0v32.657A4.274,4.274,0,0,1,609.478,205.149Z",
    transform: "translate(-605.204 -163.944)",
    fill: "#162035"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_218",
    "data-name": "Grupo 218",
    transform: "translate(32.657)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_300",
    "data-name": "Caminho 300",
    d: "M777.589,205.149a4.274,4.274,0,0,1-4.274-4.274V168.218a4.274,4.274,0,1,1,8.547,0v32.657A4.274,4.274,0,0,1,777.589,205.149Z",
    transform: "translate(-773.315 -163.944)",
    fill: "#162035"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_219",
    "data-name": "Grupo 219",
    transform: "translate(0 16.329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_301",
    "data-name": "Caminho 301",
    d: "M609.478,272.876a4.274,4.274,0,0,1-3.022-7.3l16.328-16.329a4.274,4.274,0,0,1,6.044,6.044L612.5,271.624A4.26,4.26,0,0,1,609.478,272.876Z",
    transform: "translate(-605.205 -248)",
    fill: "#069edb"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_220",
    "data-name": "Grupo 220",
    transform: "translate(16.329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_302",
    "data-name": "Caminho 302",
    d: "M693.534,188.82a4.274,4.274,0,0,1-3.022-7.3L706.841,165.2a4.274,4.274,0,1,1,6.044,6.044l-16.329,16.329A4.259,4.259,0,0,1,693.534,188.82Z",
    transform: "translate(-689.26 -163.944)",
    fill: "#da2e64"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_221",
    "data-name": "Grupo 221",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_303",
    "data-name": "Caminho 303",
    d: "M642.135,205.149a4.26,4.26,0,0,1-3.022-1.252L606.456,171.24A4.274,4.274,0,1,1,612.5,165.2l32.657,32.657a4.274,4.274,0,0,1-3.022,7.3Z",
    transform: "translate(-605.205 -163.944)",
    fill: "#162035"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_222",
    "data-name": "Grupo 222",
    transform: "translate(53.73 12.075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_304",
    "data-name": "Caminho 304",
    d: "M897.257,226.1v16.862h-3.2l-8.407-10.238v10.238h-3.854V226.1h3.228l8.383,10.237V226.1Z",
    transform: "translate(-881.792 -226.104)",
    fill: "#162035"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_305",
    "data-name": "Caminho 305",
    d: "M984.905,252.932h-9.8a3.051,3.051,0,0,0,1.252,1.9,4.146,4.146,0,0,0,2.457.7,4.972,4.972,0,0,0,1.794-.3,4.349,4.349,0,0,0,1.458-.952l2,2.168a6.72,6.72,0,0,1-5.347,2.1,8.454,8.454,0,0,1-3.878-.855,6.266,6.266,0,0,1-2.6-2.372,6.537,6.537,0,0,1-.915-3.445,6.625,6.625,0,0,1,.9-3.433,6.328,6.328,0,0,1,2.481-2.384,7.683,7.683,0,0,1,6.974-.036,5.987,5.987,0,0,1,2.421,2.349,7.009,7.009,0,0,1,.879,3.553Q984.977,251.993,984.905,252.932Zm-8.792-4.167a3.076,3.076,0,0,0-1.06,1.975h6.383a3.107,3.107,0,0,0-1.06-1.963,3.168,3.168,0,0,0-2.12-.735A3.237,3.237,0,0,0,976.113,248.765Z",
    transform: "translate(-953.928 -241.491)",
    fill: "#162035"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_306",
    "data-name": "Caminho 306",
    d: "M1049.769,259.152l-2.843-3.975-2.938,3.975h-4.095l4.986-6.528-4.818-6.432h4.215l2.746,3.782,2.818-3.782h4l-4.818,6.335,5.01,6.624Z",
    transform: "translate(-1009.181 -242.29)",
    fill: "#162035"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_307",
    "data-name": "Caminho 307",
    d: "M1122.879,246.633a5.486,5.486,0,0,1,1.614,4.324v7.4h-3.517v-1.614q-1.06,1.806-3.951,1.807a6.125,6.125,0,0,1-2.589-.506,3.857,3.857,0,0,1-1.674-1.4,3.636,3.636,0,0,1-.578-2.023,3.376,3.376,0,0,1,1.361-2.842,6.936,6.936,0,0,1,4.2-1.036h2.987a2.4,2.4,0,0,0-.747-1.891,3.29,3.29,0,0,0-2.24-.662,6.544,6.544,0,0,0-2.036.325,5.381,5.381,0,0,0-1.7.879l-1.349-2.626a8.149,8.149,0,0,1,2.541-1.156,11.383,11.383,0,0,1,3.047-.41A6.746,6.746,0,0,1,1122.879,246.633Zm-3.2,8.937a2.44,2.44,0,0,0,1.06-1.313v-1.325h-2.577q-2.312,0-2.312,1.518a1.351,1.351,0,0,0,.566,1.144,2.548,2.548,0,0,0,1.554.421A3.268,3.268,0,0,0,1119.675,255.57Z",
    transform: "translate(-1067.428 -241.491)",
    fill: "#162035"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_308",
    "data-name": "Caminho 308",
    d: "M1195.045,246.633a5.485,5.485,0,0,1,1.614,4.324v7.4h-3.517v-1.614q-1.06,1.806-3.951,1.807a6.127,6.127,0,0,1-2.589-.506,3.858,3.858,0,0,1-1.674-1.4,3.635,3.635,0,0,1-.578-2.023,3.376,3.376,0,0,1,1.36-2.842,6.937,6.937,0,0,1,4.2-1.036h2.987a2.394,2.394,0,0,0-.747-1.891,3.287,3.287,0,0,0-2.24-.662,6.544,6.544,0,0,0-2.035.325,5.4,5.4,0,0,0-1.7.879l-1.348-2.626a8.143,8.143,0,0,1,2.541-1.156,11.384,11.384,0,0,1,3.047-.41A6.746,6.746,0,0,1,1195.045,246.633Zm-3.2,8.937a2.439,2.439,0,0,0,1.06-1.313v-1.325h-2.578q-2.312,0-2.312,1.518a1.352,1.352,0,0,0,.566,1.144,2.549,2.549,0,0,0,1.554.421A3.269,3.269,0,0,0,1191.841,255.57Z",
    transform: "translate(-1125.575 -241.491)",
    fill: "#162035"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_309",
    "data-name": "Caminho 309",
    d: "M1256.865,258.148a8.24,8.24,0,0,1-2.457-1l1.252-2.7a7.875,7.875,0,0,0,2.1.9,8.771,8.771,0,0,0,2.409.349q2.385,0,2.385-1.18a.835.835,0,0,0-.65-.795,9.65,9.65,0,0,0-2-.409,19.244,19.244,0,0,1-2.626-.554,4.074,4.074,0,0,1-1.794-1.108,3.15,3.15,0,0,1-.759-2.264,3.546,3.546,0,0,1,.711-2.18,4.572,4.572,0,0,1,2.071-1.481,8.854,8.854,0,0,1,3.216-.53,12.637,12.637,0,0,1,2.734.3,7.656,7.656,0,0,1,2.252.831l-1.252,2.674a7.484,7.484,0,0,0-3.734-.964,3.8,3.8,0,0,0-1.807.337.991.991,0,0,0-.6.867.86.86,0,0,0,.651.843,11.486,11.486,0,0,0,2.072.458,22.206,22.206,0,0,1,2.6.566,3.908,3.908,0,0,1,1.759,1.1,3.112,3.112,0,0,1,.747,2.216,3.421,3.421,0,0,1-.723,2.144,4.615,4.615,0,0,1-2.108,1.457,9.4,9.4,0,0,1-3.288.518A12.6,12.6,0,0,1,1256.865,258.148Z",
    transform: "translate(-1182.024 -241.491)",
    fill: "#162035"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNexaasLogo);
export default __webpack_public_path__ + "static/media/nexaas-logo.a0bc318e340310d064e15b7d2c913090.svg";
export { ForwardRef as ReactComponent };